import { mf, msg } from '../message-functions'

/**
  <span style="color:#85c1dc;">**EE:**</span>
  Palju praktilisi nõuandeid, kuidas teha valik õige toote kasuks

  <span style="color:#85c1dc;">**FI:**</span>
  Paljon mielenkiintoisia sisustusvinkkejä

  <span style="color:#85c1dc;">**RU:**</span>
  Много интересных советов по дизайну интерьера
*/
/* @__NO_SIDE_EFFECTS__ */
const m1758 = msg(
  mf`Palju praktilisi nõuandeid, kuidas teha valik õige toote kasuks`,
  mf`Paljon mielenkiintoisia sisustusvinkkejä`,
  mf`Много интересных советов по дизайну интерьера`,
)

export { m1758 as 'w.module.blog_grid.title' }